import api from 'api/api'
import { toast } from 'react-toastify'

import { API_URL } from 'constants/env'

export const GET_SERIES_BY_PRODUCT_ID = '[SERIES] GET SERIES BY PRODUCT ID'
export const GET_PRODUCT_SERIES_BY_SEARCH = '[SERIES] GET PRODUCT SERIES BY SEARCH'
export const GET_MOVEMENT_ITEMS_TO_SERIES = '[SERIES] GET MOVEMENT ITEMS TO SERIES'
export const SAVE_MOVEMENT_PRODUCT_SERIE = '[SERIES] SAVE MOVEMENT PRODUCT SERIE'
export const REMOVE_MOVEMENT_PRODUCT_SERIE = '[SERIES] REMOVE MOVEMENT PRODUCT SERIE'

export function getSeriesByProductId(productId) {
  const request = api.get(`/product-series/by-product-id/${productId}`)
  return (dispatch) => {
    dispatch({ type: GET_SERIES_BY_PRODUCT_ID, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_SERIES_BY_PRODUCT_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo obtener las series del producto")
      console.log(GET_SERIES_BY_PRODUCT_ID, error)
    }).finally(() => {
      dispatch({ type: GET_SERIES_BY_PRODUCT_ID, payload: { loading: false } })
    })
  }
}

export function getProductSeriesBySearch(search) {
  const request = api.get(`/product-series/product-series-by-search/${search}`)
  return (dispatch) => {
    dispatch({ type: GET_PRODUCT_SERIES_BY_SEARCH, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_PRODUCT_SERIES_BY_SEARCH, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo buscar los productos y series")
      console.log(GET_PRODUCT_SERIES_BY_SEARCH, error)
    }).finally(() => {
      dispatch({ type: GET_PRODUCT_SERIES_BY_SEARCH, payload: { loading: false } })
    })
  }
}

export function getMovementItemsToSeries(movementType, movementId) {
  const request = api.get(`/product-series/movement-items-to-series/${movementType}/${movementId}`)
  return (dispatch) => {
    dispatch({ type: GET_MOVEMENT_ITEMS_TO_SERIES, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_MOVEMENT_ITEMS_TO_SERIES, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo obtener los items para el ingreso de series")
      console.log(GET_MOVEMENT_ITEMS_TO_SERIES, error)
    }).finally(() => {
      dispatch({ type: GET_MOVEMENT_ITEMS_TO_SERIES, payload: { loading: false } })
    })
  }
}

export function saveMovementProductSerie(data) {
  const request = api.post(`/product-serie/save-movement-product-serie`, data)
  const transactionId = `${data?.productId}-${data?.unitMeasureId}`
  return (dispatch) => {
    dispatch({ type: SAVE_MOVEMENT_PRODUCT_SERIE, payload: { saving_id: transactionId } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_MOVEMENT_PRODUCT_SERIE, payload: { saved_id: transactionId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo agregar la serie al item")
      console.log(SAVE_MOVEMENT_PRODUCT_SERIE, error)
    }).finally(() => {
      dispatch({ type: SAVE_MOVEMENT_PRODUCT_SERIE, payload: { saving_id: transactionId } })
    })
  }
}

export function removeMovementProductSerie(movementType, productSerieId) {
  const request = api.delete(`/product-serie/remove-movement-product-serie/${movementType}/${productSerieId}`)
  return (dispatch) => {
    dispatch({ type: REMOVE_MOVEMENT_PRODUCT_SERIE, payload: { removing_id: productSerieId } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_MOVEMENT_PRODUCT_SERIE, payload: { removed_id: productSerieId } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo remover la serie del item")
      console.log(REMOVE_MOVEMENT_PRODUCT_SERIE, error)
    }).finally(() => {
      dispatch({ type: REMOVE_MOVEMENT_PRODUCT_SERIE, payload: { removing_id: productSerieId } })
    })
  }
}

